import { CustomProvider } from 'rsuite';
import faIR from 'rsuite/locales/fa_IR';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-modern-drawer/dist/index.css';
import { RouteHandler } from './components/route-handler';
import { ScrollToTop } from './components/actions/scroll-to-top';
import { QueryClient, QueryClientProvider } from 'react-query';
import { FeedProvider } from './contexts/feed';
import { UserProvider } from './contexts/user';
import { NotificationsPopup } from './components/basic/notifications-popup';
import { useState } from 'react';
import { DiagnosisProvider } from './contexts/diagnosis';
import { ModalProvider } from './contexts/modal';
const queryClient = new QueryClient();

function App() {
  const [hideNotification, setHideNotification] = useState(true);
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <UserProvider>
          <DiagnosisProvider>
            <FeedProvider>
              <CustomProvider locale={faIR} rtl={true} theme="light">
                <ModalProvider>
                  <RouteHandler setHideNotification={setHideNotification} />
                </ModalProvider>
              </CustomProvider>
              <ToastContainer
                theme="colored"
                position="bottom-right"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={true}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />

              {hideNotification ? (
                <></>
              ) : (
                <NotificationsPopup setHideNotification={setHideNotification} />
              )}
              <ScrollToTop />
            </FeedProvider>
          </DiagnosisProvider>
        </UserProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;
